import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFichario } from '../context/ficharioContext';

const Obrigado = () => {

  const navigate = useNavigate();

  const { fetchFichario } = useFichario();

  const handleVoltar = () => {
    navigate('/'); 
  };

  const handleNavegarLogin = () => {
    navigate('/login'); 
  };


  const handleNavegarUserArea = () => {
    fetchFichario();
    navigate('/user-area'); 
  };


  return (
    <div className="obrigado-page">
      <h1>Obrigado!</h1>
      <p>Seu cálculo com os respectivos demonstrativos serão enviados para o seu e-mail cadastrado como destinatário e disponíveis na sua área do usuário.</p>
      <p className="underline" style={{ cursor: 'pointer' }} onClick={handleNavegarUserArea}>Acessar Área do Usuário</p>
      <div>
        <button className="medium-top-margin" type="button" onClick={handleVoltar}>
          Voltar ao início
        </button>
      </div>

    </div>
  );
};

export default Obrigado;
